export const coursesTranslations = {
  fr: {
    // Page index
    index: {
      title: "Cours médicaux",
      backDashboard: "Tableau de bord",
      backShort: "Retour"
    },
    hero: {
      title: "Formation médicale continue",
      subtitle: "Perfectionnez vos connaissances avec des cours créés par des professionnels de santé."
    },
    comingSoon: "Nouveaux cours bientôt disponibles",
    search: {
      placeholder: "Rechercher un cours...",
      noResults: "Aucun cours ne correspond à votre recherche."
    },
    
    // Labels communs
    labels: {
      medicalCourse: "Cours médical",
      continuingEducation: "Formation continue",
      objectivesTitle: "Objectifs pédagogiques",
      moreObjectives: "+ {{count}} autres objectifs..."
    },
    
    // Actions
    actions: {
      startCourse: "Commencer le cours"
    },
    
    // Catégories
    categories: {
      urgencies: "Urgences",
      cardiology: "Cardiologie",
      neurology: "Neurologie"
    },
    
    // Niveaux de difficulté
    difficulty: {
      beginner: "Débutant",
      intermediate: "Intermédiaire",
      advanced: "Avancé"
    },
    
    // Métadonnées des cours
    list: {
      "acr-rcp": {
        title: "ACR et Réanimation Cardio-Respiratoire",
        description: "Maîtrisez les gestes essentiels de la réanimation cardio-pulmonaire et la prise en charge de l'arrêt cardiaque.",
        duration: 45,
        categoryKey: "urgencies",
        difficultyKey: "intermediate",
        objectives: [
          "Reconnaître un arrêt cardio-respiratoire",
          "Réaliser une RCP de qualité",
          "Utiliser un défibrillateur automatisé",
          "Comprendre les algorithmes de réanimation"
        ]
      },
      "douleur-thoracique": {
        title: "Douleur thoracique – SCA, EP, Dissection Aortique",
        description: "Diagnostic différentiel et prise en charge des douleurs thoraciques graves en urgence.",
        duration: 60,
        categoryKey: "cardiology",
        difficultyKey: "advanced",
        objectives: [
          "Distinguer les urgences vitales",
          "Interpréter les examens complémentaires",
          "Initier les traitements spécifiques",
          "Reconnaître les signes de gravité"
        ]
      },
      "troubles-conscience": {
        title: "Troubles de la conscience",
        description: "Physiopathologie, diagnostic et prise en charge des altérations de la conscience et du coma.",
        duration: 75,
        categoryKey: "neurology",
        difficultyKey: "advanced",
        objectives: [
          "Comprendre la physiopathologie de la conscience",
          "Évaluer un patient comateux (échelles GCS/FOUR)",
          "Identifier les causes réversibles urgentes",
          "Maîtriser la prise en charge initiale du coma"
        ]
      },
      "avc": {
        title: "Accident Vasculaire Cérébral (AVC)",
        description: "Physiopathologie, diagnostic et prise en charge des AVC ischémiques et hémorragiques.",
        duration: 90,
        categoryKey: "neurology",
        difficultyKey: "advanced",
        objectives: [
          "Comprendre la physiopathologie de l'ischémie cérébrale",
          "Maîtriser le diagnostic différentiel des AVC",
          "Connaître les indications de thrombolyse et thrombectomie",
          "Organiser la prise en charge en urgence et la prévention secondaire"
        ]
      },
      "polytraumatise": {
        title: "Prise en charge des polytraumatisés",
        description: "Évaluation, stabilisation et stratégie de damage control du patient polytraumatisé grave.",
        duration: 90,
        categoryKey: "urgencies",
        difficultyKey: "advanced",
        objectives: [
          "Reconnaître un polytraumatisé et évaluer sa gravité (critères de Vittel, scores ISS/MGAP)",
          "Maîtriser l'approche ABCDE et la prise en charge préhospitalière",
          "Comprendre la stratégie de Damage Control (DCR et DCS)",
          "Organiser le bilan lésionnel et la prise en charge hospitalière en SAUV"
        ]
      }
    },

    // Urgentiste Masqué
    urgentisteMasque: {
      title: "L'Urgentiste masqué",
      description: "Cas cliniques authentiques issus des réseaux sociaux avec analyses détaillées",
      badgeNew: "Nouveau",
      realCases: "Cas réels",
      explore: "Explorer les cas",
      objectives: [
        "Analyse de cas cliniques réels",
        "Prises en charge aux urgences",
        "Raisonnement clinique appliqué"
      ]
    },
    
    // Navigation détail
    detail: {
      backAll: "Tous les cours",
      backShort: "Retour",
      prev: "Précédent",
      prevShort: "Préc.",
      next: "Suivant",
      nextShort: "Suiv.",
      gotoSection: "Aller à la section {{index}}",
      sectionProgress: "Section {{current}} sur {{total}}",
      notFound: "Cours non trouvé",
      keyboardHint: "💡 Utilisez les flèches ← → pour naviguer entre les sections"
    },

    // Clinical cases selector
    clinicalCases: {
      title: "Cas cliniques interactifs",
      subtitle: "Choisissez un cas clinique pour commencer l'évaluation progressive",
      backToList: "Retour à la liste",
      caseOf: "Cas {{current}}/{{total}}",
      questions: "questions",
      startCase: "Commencer le cas"
    },

    // Clinical case interactive
    clinicalCase: {
      completed: "Cas clinique terminé !",
      correctAnswers: "bonnes réponses",
      feedbackExcellent: "Excellent travail !",
      feedbackGood: "Bon travail, continuez !",
      feedbackRetry: "Révisez et réessayez !",
      restart: "Recommencer",
      showAnswer: "Voir la réponse",
      nextQuestion: "Question suivante",
      finish: "Terminer le cas",
      progress: "Progression",
      thinkFirst: "Réfléchissez à votre réponse puis cliquez sur \"Voir la réponse\"",
      correctAnswer: "Réponse correcte :",
      explanation: "Explication :"
    },

    // Quiz auto-évaluation
    quiz: {
      title: "Quiz d'auto-évaluation",
      subtitle: "Testez vos connaissances avec ces questions rapides.",
      validate: "Valider mes réponses",
      retry: "Recommencer",
      explanation: "Explication"
    }
  },
  en: {
    // Page index
    index: {
      title: "Medical Courses",
      backDashboard: "Dashboard",
      backShort: "Back"
    },
    hero: {
      title: "Continuing Medical Education",
      subtitle: "Enhance your knowledge with courses created by healthcare professionals."
    },
    comingSoon: "New courses coming soon",
    search: {
      placeholder: "Search a course...",
      noResults: "No courses match your search."
    },
    
    // Common labels
    labels: {
      medicalCourse: "Medical course",
      continuingEducation: "Continuing education",
      objectivesTitle: "Learning objectives",
      moreObjectives: "+ {{count}} more objectives..."
    },
    
    // Actions
    actions: {
      startCourse: "Start course"
    },
    
    // Categories
    categories: {
      urgencies: "Emergency Medicine",
      cardiology: "Cardiology",
      neurology: "Neurology"
    },
    
    // Difficulty levels
    difficulty: {
      beginner: "Beginner",
      intermediate: "Intermediate",
      advanced: "Advanced"
    },
    
    // Course metadata
    list: {
      "acr-rcp": {
        title: "Cardiac Arrest and Cardiopulmonary Resuscitation",
        description: "Master the essential gestures of cardiopulmonary resuscitation and cardiac arrest management.",
        duration: 45,
        categoryKey: "urgencies",
        difficultyKey: "intermediate",
        objectives: [
          "Recognize cardiorespiratory arrest",
          "Perform quality CPR",
          "Use an automated defibrillator",
          "Understand resuscitation algorithms"
        ]
      },
      "douleur-thoracique": {
        title: "Chest Pain – ACS, PE, Aortic Dissection",
        description: "Differential diagnosis and management of serious chest pain in emergency settings.",
        duration: 60,
        categoryKey: "cardiology",
        difficultyKey: "advanced",
        objectives: [
          "Distinguish life-threatening emergencies",
          "Interpret complementary examinations",
          "Initiate specific treatments",
          "Recognize severity signs"
        ]
      },
      "troubles-conscience": {
        title: "Disorders of Consciousness",
        description: "Pathophysiology, diagnosis and management of consciousness alterations and coma.",
        duration: 75,
        categoryKey: "neurology",
        difficultyKey: "advanced",
        objectives: [
          "Understand consciousness pathophysiology",
          "Evaluate a comatose patient (GCS/FOUR scales)",
          "Identify urgent reversible causes",
          "Master initial coma management"
        ]
      },
      "avc": {
        title: "Cerebrovascular Accident (Stroke)",
        description: "Pathophysiology, diagnosis and management of ischemic and hemorrhagic strokes.",
        duration: 90,
        categoryKey: "neurology",
        difficultyKey: "advanced",
        objectives: [
          "Understand cerebral ischemia pathophysiology",
          "Master stroke differential diagnosis",
          "Know thrombolysis and thrombectomy indications",
          "Organize emergency management and secondary prevention"
        ]
      },
      "polytraumatise": {
        title: "Polytrauma Patient Management",
        description: "Assessment, stabilization and damage control strategy for severe polytrauma patients.",
        duration: 90,
        categoryKey: "urgencies",
        difficultyKey: "advanced",
        objectives: [
          "Recognize a polytrauma patient and assess severity (Vittel criteria, ISS/MGAP scores)",
          "Master the ABCDE approach and prehospital management",
          "Understand the Damage Control strategy (DCR and DCS)",
          "Organize injury assessment and hospital management in the trauma bay"
        ]
      }
    },

    urgentisteMasque: {
      title: "The Masked ER Doctor",
      description: "Authentic clinical cases from social media with detailed analyses",
      badgeNew: "New",
      realCases: "Real cases",
      explore: "Explore cases",
      objectives: [
        "Analysis of real clinical cases",
        "Emergency management",
        "Applied clinical reasoning"
      ]
    },
    
    // Detail navigation
    detail: {
      backAll: "All courses",
      backShort: "Back",
      prev: "Previous",
      prevShort: "Prev",
      next: "Next",
      nextShort: "Next",
      gotoSection: "Go to section {{index}}",
      sectionProgress: "Section {{current}} of {{total}}",
      notFound: "Course not found",
      keyboardHint: "💡 Use arrow keys ← → to navigate between sections"
    },

    clinicalCases: {
      title: "Interactive clinical cases",
      subtitle: "Choose a clinical case to begin the progressive assessment",
      backToList: "Back to list",
      caseOf: "Case {{current}}/{{total}}",
      questions: "questions",
      startCase: "Start case"
    },

    clinicalCase: {
      completed: "Clinical case completed!",
      correctAnswers: "correct answers",
      feedbackExcellent: "Excellent work!",
      feedbackGood: "Good job, keep it up!",
      feedbackRetry: "Review and try again!",
      restart: "Start over",
      showAnswer: "Show answer",
      nextQuestion: "Next question",
      finish: "Finish case",
      progress: "Progress",
      thinkFirst: "Think about your answer then click \"Show answer\"",
      correctAnswer: "Correct answer:",
      explanation: "Explanation:"
    },

    quiz: {
      title: "Self-assessment Quiz",
      subtitle: "Test your knowledge with these quick questions.",
      validate: "Submit answers",
      retry: "Start over",
      explanation: "Explanation"
    }
  },
  es: {
    // Página índice
    index: {
      title: "Cursos Médicos",
      backDashboard: "Panel de control",
      backShort: "Volver"
    },
    hero: {
      title: "Formación Médica Continua",
      subtitle: "Perfeccione sus conocimientos con cursos creados por profesionales de la salud."
    },
    comingSoon: "Nuevos cursos próximamente",
    search: {
      placeholder: "Buscar un curso...",
      noResults: "Ningún curso coincide con tu búsqueda."
    },
    
    // Etiquetas comunes
    labels: {
      medicalCourse: "Curso médico",
      continuingEducation: "Formación continua",
      objectivesTitle: "Objetivos pedagógicos",
      moreObjectives: "+ {{count}} objetivos más..."
    },
    
    // Acciones
    actions: {
      startCourse: "Comenzar curso"
    },
    
    // Categorías
    categories: {
      urgencies: "Medicina de Urgencias",
      cardiology: "Cardiología",
      neurology: "Neurología"
    },
    
    // Niveles de dificultad
    difficulty: {
      beginner: "Principiante",
      intermediate: "Intermedio",
      advanced: "Avanzado"
    },
    
    // Metadatos de cursos
    list: {
      "acr-rcp": {
        title: "PCR y Reanimación Cardiopulmonar",
        description: "Domine los gestos esenciales de la reanimación cardiopulmonar y el manejo del paro cardíaco.",
        duration: 45,
        categoryKey: "urgencies",
        difficultyKey: "intermediate",
        objectives: [
          "Reconocer un paro cardiorrespiratorio",
          "Realizar RCP de calidad",
          "Usar un desfibrilador automatizado",
          "Comprender los algoritmos de reanimación"
        ]
      },
      "douleur-thoracique": {
        title: "Dolor Torácico – SCA, EP, Disección Aórtica",
        description: "Diagnóstico diferencial y manejo de dolores torácicos graves en urgencias.",
        duration: 60,
        categoryKey: "cardiology",
        difficultyKey: "advanced",
        objectives: [
          "Distinguir emergencias vitales",
          "Interpretar exámenes complementarios",
          "Iniciar tratamientos específicos",
          "Reconocer signos de gravedad"
        ]
      },
      "troubles-conscience": {
        title: "Trastornos de la Conciencia",
        description: "Fisiopatología, diagnóstico y manejo de las alteraciones de la conciencia y el coma.",
        duration: 75,
        categoryKey: "neurology",
        difficultyKey: "advanced",
        objectives: [
          "Comprender la fisiopatología de la conciencia",
          "Evaluar un paciente comatoso (escalas GCS/FOUR)",
          "Identificar causas reversibles urgentes",
          "Dominar el manejo inicial del coma"
        ]
      },
      "avc": {
        title: "Accidente Cerebrovascular (ACV)",
        description: "Fisiopatología, diagnóstico y manejo de ACV isquémicos y hemorrágicos.",
        duration: 90,
        categoryKey: "neurology",
        difficultyKey: "advanced",
        objectives: [
          "Comprender la fisiopatología de la isquemia cerebral",
          "Dominar el diagnóstico diferencial de ACV",
          "Conocer las indicaciones de trombólisis y trombectomía",
          "Organizar el manejo de urgencia y la prevención secundaria"
        ]
      },
      "polytraumatise": {
        title: "Manejo del paciente politraumatizado",
        description: "Evaluación, estabilización y estrategia de control de daños del paciente politraumatizado grave.",
        duration: 90,
        categoryKey: "urgencies",
        difficultyKey: "advanced",
        objectives: [
          "Reconocer un politraumatizado y evaluar su gravedad (criterios de Vittel, scores ISS/MGAP)",
          "Dominar el enfoque ABCDE y el manejo prehospitalario",
          "Comprender la estrategia de Damage Control (DCR y DCS)",
          "Organizar el balance lesional y el manejo hospitalario en la sala de emergencias"
        ]
      }
    },

    urgentisteMasque: {
      title: "El Urgenciólogo enmascarado",
      description: "Casos clínicos auténticos de redes sociales con análisis detallados",
      badgeNew: "Nuevo",
      realCases: "Casos reales",
      explore: "Explorar casos",
      objectives: [
        "Análisis de casos clínicos reales",
        "Manejo en urgencias",
        "Razonamiento clínico aplicado"
      ]
    },
    
    // Navegación detalle
    detail: {
      backAll: "Todos los cursos",
      backShort: "Volver",
      prev: "Anterior",
      prevShort: "Ant.",
      next: "Siguiente",
      nextShort: "Sig.",
      gotoSection: "Ir a la sección {{index}}",
      sectionProgress: "Sección {{current}} de {{total}}",
      notFound: "Curso no encontrado",
      keyboardHint: "💡 Usa las flechas ← → para navegar entre secciones"
    },

    clinicalCases: {
      title: "Casos clínicos interactivos",
      subtitle: "Elige un caso clínico para comenzar la evaluación progresiva",
      backToList: "Volver a la lista",
      caseOf: "Caso {{current}}/{{total}}",
      questions: "preguntas",
      startCase: "Comenzar caso"
    },

    clinicalCase: {
      completed: "¡Caso clínico completado!",
      correctAnswers: "respuestas correctas",
      feedbackExcellent: "¡Excelente trabajo!",
      feedbackGood: "¡Buen trabajo, sigue así!",
      feedbackRetry: "¡Revisa e inténtalo de nuevo!",
      restart: "Reiniciar",
      showAnswer: "Ver respuesta",
      nextQuestion: "Siguiente pregunta",
      finish: "Terminar caso",
      progress: "Progreso",
      thinkFirst: "Piensa en tu respuesta y luego haz clic en \"Ver respuesta\"",
      correctAnswer: "Respuesta correcta:",
      explanation: "Explicación:"
    },

    quiz: {
      title: "Quiz de autoevaluación",
      subtitle: "Pon a prueba tus conocimientos con estas preguntas rápidas.",
      validate: "Validar respuestas",
      retry: "Reiniciar",
      explanation: "Explicación"
    }
  }
};